// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Abel-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/BellotaText-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Abel';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'BellotaText';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}


:root {
    /* fonts */
    --display-font: 'BellotaText';
    --primary-font: 'Abel';

    /* colors */
    --bg-color: #000000;
    --secondary-bg-color: #0f0e10;
    --tertiary-bg-color: #0D0B0C;
    --shadow-grey: #27272C;
    --fg-color: #fff;

    /* text colors */
    --primary-text-color: #f3f5f3;
    --secondary-text-color: #444448;
    --border-color: #27272C;
}

* {
    box-sizing: border-box;
}

body {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--bg-color);
    font-family: var(--primary-font);
    height: 100vh;
    color: var(--primary-text-color);
}

h1,
h2,
h3,
p {
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,4DAA6D;IAC7D,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,4DAAoE;IACpE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,UAAU;IACV,6BAA6B;IAC7B,sBAAsB;;IAEtB,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;;IAEhB,gBAAgB;IAChB,6BAA6B;IAC7B,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,gCAAgC;IAChC,aAAa;IACb,gCAAgC;AACpC;;AAEA;;;;IAII,SAAS;AACb","sourcesContent":["@font-face {\n    font-family: 'Abel';\n    src: url('./assets/fonts/Abel-Regular.woff2') format('woff2');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'BellotaText';\n    src: url('./assets/fonts/BellotaText-Regular.woff2') format('woff2');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n\n:root {\n    /* fonts */\n    --display-font: 'BellotaText';\n    --primary-font: 'Abel';\n\n    /* colors */\n    --bg-color: #000000;\n    --secondary-bg-color: #0f0e10;\n    --tertiary-bg-color: #0D0B0C;\n    --shadow-grey: #27272C;\n    --fg-color: #fff;\n\n    /* text colors */\n    --primary-text-color: #f3f5f3;\n    --secondary-text-color: #444448;\n    --border-color: #27272C;\n}\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--bg-color);\n    font-family: var(--primary-font);\n    height: 100vh;\n    color: var(--primary-text-color);\n}\n\nh1,\nh2,\nh3,\np {\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
